import { RevokeTrustBtnData } from './luigiConfig/custom-message-listeners/revoke-trust-btn-data';
import { Injectable, signal } from '@angular/core';
import * as LuigiClient from '@luigi-project/client';
import { LuigiCoreService, LuigiNodesService } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class ExtensionTrustSettingsService {
  sendUpdateToClient() {
    this.luigiCoreService
      .customMessages()
      .sendToAll({ id: 'extension-trust.update-client', data: this.trustData });
  }

  private storageKey = 'project-level-extension-trust';
  showTrustDialog = signal(true);
  showRevokeTrustButton = signal(false);
  trustData: RevokeTrustBtnData | null = null;
  constructor(
    private luigiCoreService: LuigiCoreService,
    private luigiNodesService: LuigiNodesService,
  ) {}

  setTrustData(trustData: RevokeTrustBtnData) {
    if (!trustData) {
      return;
    }
    this.trustData = trustData;
    this.showTrustDialog.set(!this.isTrusted(trustData.projectId));
    this.showRevokeTrustButton.set(
      this.isTrusted(trustData.projectId) &&
        this.trustData.isProjectLevelExtension,
    );
  }

  requestTrustDataSync() {
    LuigiClient.sendCustomMessage({ id: 'extension-trust.request-update' });
  }

  isTrusted(projectId: string): boolean {
    const trustValuesEntry = localStorage.getItem(this.storageKey);
    try {
      const trustValues = JSON.parse(trustValuesEntry ?? '');
      return Boolean(trustValues[projectId]);
    } catch (_) {
      return false;
    }
  }

  trustProject() {
    const trustValueEntry = localStorage.getItem(this.storageKey);
    try {
      const trustValue = JSON.parse(trustValueEntry ?? '');
      trustValue[this.trustData?.projectId ?? ''] = true;
      localStorage.removeItem(this.storageKey);
      localStorage.setItem(this.storageKey, JSON.stringify(trustValue));
    } catch (_) {
      const projectValue: Record<string, unknown> = {};
      projectValue[this.trustData?.projectId ?? ''] = true;
      localStorage.setItem(this.storageKey, JSON.stringify(projectValue));
    } finally {
      LuigiClient.sendCustomMessage({ id: 'extension-trust.reload', data: {} });
    }
  }

  // Scales with the amount of projects a user is actively using
  revokeTrust() {
    const trustValueEntry = localStorage.getItem(this.storageKey);
    try {
      const trustValue = JSON.parse(trustValueEntry ?? '');
      trustValue[this.trustData?.projectId ?? ''] = false;
      localStorage.removeItem(this.storageKey);
      localStorage.setItem(this.storageKey, JSON.stringify(trustValue));
    } catch (_) {
      return;
    } finally {
      this.showTrustDialog.set(true);
      this.showRevokeTrustButton.set(false);
      this.luigiNodesService.clearNodeCache();
      this.luigiCoreService.clearNavigationCache();
      this.luigiCoreService.configChanged();
      this.sendUpdateToClient();
    }
  }
}
